import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withSnackbar } from "notistack";
import { Link as RouterLink } from "react-router-dom";
import { Tab, Tabs, Box, Container, Grid, Typography, Link, withStyles, withTheme } from "@material-ui/core";

import PrivacyPolicyNotification from "../../../shared/component/privacyPolicyNotification";
import { doNotification } from "../../../shared/component/notifier";
import Timeout from "../../../shared/component/timeout";
import Slider from "../../../shared/component/slider";
import { TIMEOUT_ID } from "../../../../constants.js";
import { verifyUser } from "../../redux/auth.action";

import interswitchLogo from "../../../../images/logo.svg";
import RegisterLinks from "./registerLinks";
import LoginForm from "./loginForm";

const styles = theme => ({
    root: {
        flexGrow: 1,
        padding: 0,
        color: "#696b74",
        height: "100vh",
        position: "fixed",
        maxWidth: "inherit"
    },
    navbarImg: {
        width: 150
    },
    grow: {
        flexGrow: 1,
        display: "flex",
        justifyContent: "flex-end",
        paddingTop: theme.spacing(1) + 5,
        paddingRight: theme.spacing(2) + 6
    },
    rightSection: {
        height: "100%",
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2)
    },
    loginWrap: {
        marginTop: "15vh"
    },
    txtSm: {
        fontSize: "0.85rem"
    },
    txtLink: {
        color: "#019ee2"
    },
    txtTitle: {
        fontWeight: 700,
        color: "#01425e",
        fontSize: "1.8rem",
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        [theme.breakpoints.down("sm")]: {
            fontSize: "1.5rem"
        }
    },
    resetLink: {
        marginTop: -theme.spacing(2),
        marginBottom: -theme.spacing(2)
    },
    card: {
        borderTop: "3px solid #019ee2",
        [theme.breakpoints.up("sm")]: {
            margin: "auto 32px"
        }
    },
    form: {
        color: "#696b74",
        marginTop: -theme.spacing(3),
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        [theme.breakpoints.down("sm")]: {
            paddingLeft: theme.spacing(1),
            paddingRight: theme.spacing(1)
        },
        [theme.breakpoints.down("xs")]: {
            paddingLeft: theme.spacing(0.5),
            paddingRight: theme.spacing(0.5)
        }
    },
    dvdSection: {
        marginTop: -8,
        "& .MuiDivider-inset": {
            marginLeft: theme.spacing(0)
        }
    },
    createBtn: {
        marginTop: theme.spacing(1)
    }
});

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <Typography
            component="div"
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && <Box p={3}>{children}</Box>}
        </Typography>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired
};

function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        "aria-controls": `full-width-tabpanel-${index}`
    };
}

class Login extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            value: 0
        };

        this.handleChangeIndex = this.handleChangeIndex.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {
        const { match, verifyUser } = this.props;
        const { uuid } = match.params;

        if (uuid) {
            verifyUser({ uuid });
        }
        this.scrollToTop();
    }

    componentDidUpdate(prevProps) {
        const { enqueueSnackbar, closeSnackbar, errorLoad, successLoad, history } = this.props;

        if (successLoad && prevProps.successLoad !== successLoad) {
            const message = "Account verification was successful! Please sign in to continue";
            this.notify = doNotification(enqueueSnackbar, closeSnackbar, message, "success");
            history.push("/login");
        }

        if (errorLoad && prevProps.errorLoad !== errorLoad) {
            this.notify = doNotification(enqueueSnackbar, closeSnackbar, errorLoad, "error");
        }
    }

    handleChange(event, newValue) {
        this.setState({ value: newValue });
    }

    handleChangeIndex(index) {
        this.setState({ value: index });
    }

    scrollToTop() {
        window.scrollTo(0, 0);
    }

    render() {
        const { history, classes, theme } = this.props;
        const { value } = this.state;

        return (
            <React.Fragment>
                <Timeout idle={window.sessionStorage.getItem(TIMEOUT_ID)} />
                <PrivacyPolicyNotification />
                <Container className={classes.root}>
                    <Grid container style={{ height: "100%" }}>
                        <Grid item md={7}>
                            <Slider />
                        </Grid>
                        <Grid item md={5} className={classes.rightSection}>
                            <Grid item>
                                <Typography className={classes.grow}>
                                    <Link component={RouterLink} to="/">
                                        <img src={interswitchLogo} alt="Interswitch" className={classes.navbarImg} />
                                    </Link>
                                </Typography>
                            </Grid>
                            <Grid item container spacing={2} className={classes.loginWrap}>
                                <Grid item xs={12}>
                                    <Grid container justify="center">
                                        <Grid item md={7} sm={9} xs={12}>
                                            <Typography variant="h4" align="center" className={classes.txtTitle}>
                                                Welcome
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12}>
                                    <Grid container justify="center">
                                        <Grid item md={9} sm={9} xs={12}>
                                            <Tabs
                                                value={value}
                                                onChange={this.handleChange}
                                                indicatorColor="secondary"
                                                textColor="inherit"
                                                variant="fullWidth"
                                                aria-label="full width tabs example"
                                            >
                                                <Tab label="Log In" {...a11yProps(0)} />
                                                <Tab label="Register" {...a11yProps(1)} />
                                            </Tabs>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12}>
                                    <TabPanel value={value} index={0} dir={theme.direction}>
                                        <Grid container justify="center">
                                            <Grid item md={9} sm={9} xs={12}>
                                                <LoginForm history={history} classes={classes} />
                                            </Grid>
                                        </Grid>
                                    </TabPanel>
                                    <TabPanel value={value} index={1} dir={theme.direction}>
                                        <Grid container justify="center">
                                            <Grid item md={9} sm={9} xs={12}>
                                                <RegisterLinks classes={classes} />
                                            </Grid>
                                        </Grid>
                                    </TabPanel>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Container>
            </React.Fragment>
        );
    }
}

Login.propTypes = {
    isLoading: PropTypes.bool,
    errorLoad: PropTypes.string,
    successLoad: PropTypes.string,
    enqueueSnackbar: PropTypes.any,
    closeSnackbar: PropTypes.any,
    verifyUser: PropTypes.func
};

function mapStateToProps({ rxAuth }) {
    return {
        isLoading: rxAuth.verifyUserLoading,
        errorLoad: rxAuth.verifyUserError,
        successLoad: rxAuth.verifyUserSuccess
    };
}

export default connect(mapStateToProps, {
    verifyUser
})(withSnackbar(withTheme(withStyles(styles)(Login))));
